<script>
export default {
  name: 'TermsOfServiceForInfluencer'
}
</script>

<template lang="pug" src="./TermsOfServiceForInfluencer.pug"></template>
